import { computed, onBeforeMount, ref } from 'vue';
import ApiClient from '@/ApiClient';
import { divisionsAsScopeField } from '@/pages/recognition/constants';

const scopeFields = ref([]);
let loaded = null;

export const fetchScopeFields = async () => {
  try {
    return (await ApiClient.getRecognitionScopeFields())?.data || [];
  } catch {
    try {
      return [divisionsAsScopeField((await ApiClient.getDivisions())?.data)];
    } catch {
      return [];
    }
  }
};

export const scopeOptionValue = (key, value) => JSON.stringify([key, value]);
export const scopeOptionEntry = optionValue => JSON.parse(optionValue);

export const scopeFilterOptions = fields => [
  { value: null, text: 'Entire company' },
  ...(fields || [])
    .filter(field => field.values?.length)
    .map(field => ({
      label: field.label,
      options: field.values.map(v => ({ value: scopeOptionValue(field.key, v.value), text: v.label })),
    })),
];

export const scopeFromSelection = selected => {
  if (!selected) {
    return null;
  }
  const [key, value] = scopeOptionEntry(selected);
  return { [key]: [value] };
};

export const matchesScopeFilter = (scope, filter, { unscopedMatches = false } = {}) =>
  Object.entries(filter || {}).every(([key, values]) => {
    const own = scope?.[key] || [];
    return own.length ? values.some(value => own.includes(String(value))) : unscopedMatches;
  });

export default () => {
  onBeforeMount(async () => {
    loaded = loaded || fetchScopeFields();
    scopeFields.value = await loaded;
    if (!scopeFields.value.length) {
      loaded = null;
    }
  });

  const selected = ref(null);
  const options = computed(() => scopeFilterOptions(scopeFields.value));
  const scope = computed(() => scopeFromSelection(selected.value));
  const scopeParam = computed(() => (scope.value ? JSON.stringify(scope.value) : undefined));
  const hasOptions = computed(() => options.value.length > 1);

  return { selected, options, scope, scopeParam, hasOptions };
};
